import React from 'react';

// Vector version of the brand mark: a screen with </> and a lightning crack.
const LogoMark = ({ size = 34 }) => (
  <svg
    className="logo-mark"
    width={size}
    height={(size * 48) / 64}
    viewBox="0 0 64 48"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M44 5H12a7 7 0 0 0-7 7v24a7 7 0 0 0 7 7h40a7 7 0 0 0 7-7V17"
      stroke="currentColor"
      strokeWidth="4.5"
      strokeLinecap="round"
    />
    <path
      className="logo-bolt"
      d="M55 1l-6 9 5 1.5-7 10"
      stroke="var(--accent)"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 18l-6 6 6 6M40 18l6 6-6 6M35 15l-6 18"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogoMark;
